import { FontSizeHotkey, FontSizeOptions } from './options'

export * from './plugin/with-font-size'
export * from './plugin/font-size-editor'
export type { FontSizeOptions, FontSizeHotkey }
